import axios from "../../utils/axios";

// 轮播图管理
export function getList(query) {
    return axios({
        url: "slidePicManage/getList",
        method: "get",
        params: query
    });
}

// 轮播图管理
export function getBannerList(query) {
    return axios({
        url: "slidePicManage/getBannerList",
        method: "get",
        params: query
    });
}

//轮播图删除
export function deleteSlidePic(data) {
    return axios({
        url: "slidePicManage/delete",
        method: "post",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        data: data
    });
}

//轮播图删除
export function bannerDeleteSlidePic(data) {
    return axios({
        url: "slidePicManage/bannerDelete",
        method: "post",
        params: data
    });
}

// 轮播图增加
export function addSlidePic(data) {
    return axios({
        url: "slidePicManage/update",
        method: "post",
        data: data
    });
}

// 轮播图增加
export function addBanner(data) {
    return axios({
        url: "slidePicManage/bannerUpdate",
        method: "post",
        data: data
    });
}

// 轮播图修改
export function updateSlidePic(data) {
    return axios({
        url: "slidePicManage/update",
        method: "post",
        data: data
    });
}

// 轮播图修改
export function updateBanner(data) {
    return axios({
        url: "slidePicManage/bannerUpdate",
        method: "post",
        data: data
    });
}



// 改变状态
export function changeStatus(data) {
    return axios({
        url: "slidePicManage/update",
        method: "post",
        data: data
    });
}

// banner改变状态
export function bannerStatus(params) {
    return axios({
        url: "slidePicManage/bannerUpdate",
        method: "post",
        data: params
    });
}

// 查询开启数量
export function getCount() {
    return axios({
        url: "slidePicManage/getCount",
        method: "get"
    });
}

